module.exports = __webpack_public_path__ + "img/logo.e43211a3.svg";